import type { ComboBoxOption } from '../../../cdl/ComboBox/ComboBox';
import type { ComboBoxValueComponentProps } from '../../../cdl/ComboBox/types/ComboBoxComponentProps';
import { Tag } from '../../../cdl/Tag/Tag';
import { Text } from '../../../cdl/Text/Text';
import { Box } from '../../../common/ui/Box';

export const SupplierGroupSingleValue = ({ option }: ComboBoxValueComponentProps<ComboBoxOption>) => {
    return (
        <Box display="flex" alignItems="center" justifyContent="space-between" width="100%" gap={8} minWidth={0}>
            <Text
                display="block"
                style={{ flex: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
            >
                {option.label}
            </Text>
            <Box flexShrink={0}>
                <Tag variant="default">{option.value}</Tag>
            </Box>
        </Box>
    );
};
